<template>
  <div id="app">
    <!-- v-if="!dialogFormVisible" -->
    <router-view />


  </div>
</template>
<script>
export default {
  name: 'App',
  components: {},
  data() {
    return {

    }
  },
  methods: {

    async initData() {

    }
  }
}

</script>

<style lang="scss">
html,
body,
#app {
  height: 100%;
}

html {
  background-image: url(@/assets/img/bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

#app {
  background-size: 100%;
}


// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
// }

// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }</style>
